import PropTypes from 'prop-types';

const HeadphonesIcon = ({ className = '' }) => (
  <svg
    width="215"
    height="215"
    viewBox="0 0 215 215"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <mask
      id="mask0_8575_2948"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="215"
      height="215"
    >
      <path
        d="M203.938 0H11.0611C4.9522 0 0 4.95219 0 11.061V203.938C0 210.047 4.95219 214.999 11.061 214.999H203.938C210.047 214.999 214.999 210.047 214.999 203.938V11.0611C214.999 4.9522 210.047 0 203.938 0Z"
        fill="#C9E3F7"
      />
    </mask>
    <g mask="url(#mask0_8575_2948)">
      <path
        d="M198.999 0H16C7.16344 0 0 7.16343 0 16V198.999C0 207.835 7.16343 214.999 16 214.999H198.999C207.835 214.999 214.999 207.835 214.999 198.999V16C214.999 7.16344 207.835 0 198.999 0Z"
        fill="#F4EFED"
      />
      <path
        d="M178.498 138.212C178.498 168.374 155.284 192.826 126.649 192.826M157.619 139.645V66.2724C157.619 35.3979 135.18 10.3691 107.499 10.3691C79.8183 10.3691 57.3787 35.3979 57.3787 66.2724V139.645"
        stroke="white"
        strokeWidth="20.7395"
      />
      <path
        d="M-0.00170898 67.999H46.9983V139.999H-0.00170898V67.999Z"
        fill="#0A0777"
      />
      <rect x="167.998" y="67.999" width="47" height="72" fill="#0A0777" />
      <ellipse
        cx="107.499"
        cy="192.877"
        rx="21.7764"
        ry="22.1221"
        fill="#FB6E44"
      />
    </g>
  </svg>
);

HeadphonesIcon.propTypes = {
  className: PropTypes.string
};

export default HeadphonesIcon;
